{
  "attachAria": "Allega file",
  "emptyHint": "Descrivi il problema: l'assistenza ti risponderà qui",
  "emptyTitle": "Ancora nessun messaggio",
  "fileOpenAria": "Apri allegato",
  "logAria": "Conversazione della richiesta",
  "newMessages": "Nuovi messaggi",
  "placeholder": "Scrivi un messaggio…",
  "placeholderDisabled": "I messaggi sono temporaneamente non disponibili",
  "previewAria": "Visualizza allegato",
  "previewCloseAria": "Chiudi anteprima",
  "removeAttachmentAria": "Rimuovi file",
  "retry": "Riprova",
  "screenshotAria": "Fai uno screenshot",
  "seen": "Visto",
  "sendAria": "Invia messaggio",
  "sendFailed": "Impossibile inviare il messaggio",
  "sending": "Invio…",
  "student": "Studente",
  "supportName": "Assistenza Skyeng",
  "today": "Oggi",
  "yesterday": "Ieri",
  "you": "Tu"
}
